// @react
import React, { ReactElement, useRef } from 'react'
// @typings
import { ContactFormValues } from 'modules/common/forms/types/contact'
// @libraries
import { Control, Controller, FieldErrors } from 'react-hook-form'
// @components
import Grid from '@bit/atd.web.grid'
import InputText from '@bit/atd.web.forms.input-text'
import InputSectionLabel from '@bit/atd.web.forms.input-section-label'
import Hidden from '@material-ui/core/Hidden'
import strings from 'lib/constants/strings'

type PropsType = {
  control: Control<ContactFormValues>
  errors: FieldErrors<ContactFormValues>
}

const EmailFields = ({ control, errors }: PropsType): ReactElement => {
  /****************************************
   * HOOKS
   *****************************************/

  const EmailRef = useRef<HTMLInputElement | null>(null)

  /****************************************
   * RENDER
   *****************************************/

  return (
    <>
      <Grid xs={12} item>
        <InputSectionLabel component={'legend'}>Email</InputSectionLabel>
      </Grid>

      {/* Email */}
      <Grid xs={12} sm={6} item>
        <Controller
          control={control}
          name="primaryEmailAddress"
          onFocus={() => EmailRef?.current?.focus()}
          render={({ onChange, onBlur, value, name }) => (
            <InputText
              required
              disabled
              name={name}
              label="Email Address"
              placeholder={strings.PROFILE.ACCESS.PRIMARY_EMAIL_PLACEHOLDER}
              type="email"
              value={value as string}
              inputRef={EmailRef}
              onBlur={onBlur}
              onChange={onChange}
              error={!!errors?.primaryEmailAddress}
              errorText={errors?.primaryEmailAddress?.message}
            />
          )}
        />
      </Grid>

      <Hidden xsDown>
        <Grid xs={6} item />
      </Hidden>
    </>
  )
}

export default EmailFields
